import { useEffect, useState } from 'react';
import { api } from '../api';
import DogCard from '../components/DogCard';
import './Dogs.css';

export default function Dogs() {
  const [dogs,    setDogs]    = useState([]);
  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState({ status: 'available', gender: '', size: '' });

  useEffect(() => {
    setLoading(true);
    const params = Object.entries(filters)
      .filter(([, v]) => v)
      .map(([k, v]) => `${k}=${v}`)
      .join('&');
    api.getDogs(params)
      .then(setDogs)
      .finally(() => setLoading(false));
  }, [filters]);

  const setFilter = (key, value) => setFilters(f => ({ ...f, [key]: value }));

  return (
    <div className="dogs-page">
      <div className="dogs-page__hero">
        <div className="container">
          <h1>Available Dogs</h1>
          <p>Every dog here is waiting for their forever home. Could that be with you?</p>
        </div>
      </div>

      <div className="container">
        {/* Filters */}
        <div className="dogs-filters">
          <div className="dogs-filters__group">
            <label className="form-label">Status</label>
            <div className="dogs-filters__pills">
              {[
                { v: 'available', l: 'Available' },
                { v: 'pending',   l: 'Pending'   },
                { v: 'adopted',   l: 'Adopted'   },
                { v: '',          l: 'All'        },
              ].map(o => (
                <button
                  key={o.v}
                  className={`pill ${filters.status === o.v ? 'pill--active' : ''}`}
                  onClick={() => setFilter('status', o.v)}
                >
                  {o.l}
                </button>
              ))}
            </div>
          </div>

          <div className="dogs-filters__group">
            <label className="form-label">Gender</label>
            <div className="dogs-filters__pills">
              {[
                { v: '',       l: 'Any'    },
                { v: 'male',   l: 'Male'   },
                { v: 'female', l: 'Female' },
              ].map(o => (
                <button
                  key={o.v}
                  className={`pill ${filters.gender === o.v ? 'pill--active' : ''}`}
                  onClick={() => setFilter('gender', o.v)}
                >
                  {o.l}
                </button>
              ))}
            </div>
          </div>

          <div className="dogs-filters__group">
            <label className="form-label">Size</label>
            <div className="dogs-filters__pills">
              {[
                { v: '',           l: 'Any'        },
                { v: 'small',      l: 'Small'      },
                { v: 'medium',     l: 'Medium'     },
                { v: 'large',      l: 'Large'      },
                { v: 'extra_large',l: 'XL'         },
              ].map(o => (
                <button
                  key={o.v}
                  className={`pill ${filters.size === o.v ? 'pill--active' : ''}`}
                  onClick={() => setFilter('size', o.v)}
                >
                  {o.l}
                </button>
              ))}
            </div>
          </div>
        </div>

        {/* Results */}
        {loading ? (
          <div className="loading-center"><div className="spinner" /></div>
        ) : dogs.length === 0 ? (
          <div className="dogs-empty">
            <div className="dogs-empty__icon">🐾</div>
            <h3>No dogs found</h3>
            <p>Try adjusting your filters, or check back soon — new dogs arrive regularly!</p>
            <button className="btn btn-primary" onClick={() => setFilters({ status: '', gender: '', size: '' })}>
              Clear Filters
            </button>
          </div>
        ) : (
          <>
            <p className="dogs-count">{dogs.length} dog{dogs.length !== 1 ? 's' : ''} found</p>
            <div className="dogs-grid">
              {dogs.map(dog => <DogCard key={dog.id} dog={dog} />)}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
